export default __webpack_public_path__ + "static/media/093-chevron-3.3a9a0c4a.png";